import React, { useState } from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'
import { useDispatch } from 'react-redux'
import { isPresignedUploadInProgress } from 'Manage/actions'

import styles from './ProcessingFilesAlert.module.css'

function ProcessingFilesAlert({ show }) {
  const dispatch = useDispatch()
  const [isCancelling, setIsCancelling] = useState(false)

  const handleCancel = async () => {
    setIsCancelling(true)
    // dispatch(isPresignedUploadInProgress(false))
    window.cancelPresignedUpload = true
  }

  if (!show || localStorage.getItem('cancelPresignedUpload') === 'true') return null

  return (
    <div className={`${styles.container} p-4 mb-5`}>
      <div className="text-start font-24 bold">
        <img
          alt="warning"
          src="/assets/icons/warning_black.svg"
          height={22}
          width={22}
          className="me-2"
          style={{ marginTop: '-4px' }}
        />
        Please don’t close this window
      </div>
      <div className="flex flex-column gap-2">
        <div className="font-18 text-start mt-2">
          We’re uploading your files in the background. Please don&apos;t close the window or navigate away from the
          page on this tab.
        </div>
        <ProgressBar animated now={100} />
        <div className="d-flex justify-content-end mt-2">
          <Button variant="outline-danger" size="sm" onClick={handleCancel} disabled={isCancelling}>
            {isCancelling ? (
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
            ) : (
              'Cancel'
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ProcessingFilesAlert
